import React from 'react'
import { useIntl } from 'react-intl'
import { UserRole } from '../../../../common/types'
import { BigButtonSection } from '../../../../components/layout'
import { Styling } from '../../../../components/Styling'
import { DutyOfficerButtons } from './DutyOfficer'
import { MainUserButtons } from './MainUser'
import { SaveButton } from './SaveButton'
import { TowingOrderSaveButtonsProps } from './types'

export const TowingOrderSaveButtons: React.FunctionComponent<TowingOrderSaveButtonsProps> = (
  props: TowingOrderSaveButtonsProps
) => {
  const { userId, handleSubmit, userRole } = props
  const { formatMessage } = useIntl()

  if (userRole === UserRole.main_user) {
    return <MainUserButtons {...props} />
  }

  if (userRole === UserRole.duty_officer) {
    return <DutyOfficerButtons {...props} />
  }

  return (
    <BigButtonSection justifyContent="end">
      <>
        <SaveButton onClick={() => handleSubmit(false, null, 'open')}>
          <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.save' })}</Styling>
          <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.openToAll' })}</Styling>
        </SaveButton>
        <SaveButton onClick={() => handleSubmit(false, userId, 'assigned')}>
          <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.saveAnd' })}</Styling>
          <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.acceptToSelf' })}</Styling>
        </SaveButton>
      </>
    </BigButtonSection>
  )
}
